<mat-card class="container-card mat-elevation-z8">
    <mat-card-content>
        <div class="input-row-grid p-3">
            <mat-form-field appearance="fill" class="alias-select w-100">
                <mat-label>Seleziona Alias</mat-label>
                <mat-select [(value)]="selectedAlias" (selectionChange)="onAliasChanged()">
                    <mat-option *ngFor="let alias of aliasOptions" [value]="alias.value">
                        {{ alias.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <button class="btn-primary mb-3 btn-show" [disabled]="!selectedAlias" (click)="mostraDocumenti()">
          Mostra Documenti
        </button>
        </div>

        <app-search-bar [filterFields]="['q']" [filterMap]="{ q: ['q'] }" [filterLabels]="{ q: ['contenuto del documento'] }" (filtersChanged)="onFilterChanged($event)">
        </app-search-bar>

        <app-shared-table [dataSource]="dataSourceAliasDocuments" [displayedColumns]="['title', 'url', 'actions']" [columnLabels]="{ title: 'Nome', url: 'URL' }" [notAllowEdit]="true" [notAllowDelete]="true" [notAllowAdd]="true" [enableRowClick]="true" (rowClick)="goToDetail($event)"
            [length]="totalItems" [pageSize]="limit" [pageIndex]="pageIndex" (pageChanged)="onPageChanged($event)" (sortChanged)="onSortChanged($event)" [nameTable]="'diagnostics'" [isLoading]="isLoading" [hasError]="hasError">
        </app-shared-table>
    </mat-card-content>
</mat-card>